export const FETCH_YEARLIST = "fetchYears";
export const FETCH_ELECTIONLIST = "fetchElections";
export const FETCH_CONTESTLIST = "fetchContests";
export const FETCH_CANDIDATELIST = "fetchCandidates";
export const FETCH_PUBLISHEDCANDIDATESTATEMENT = "fetchPublishedCandidateStatements";
export const SET_CONTEST_USING_SELECTED_CANDIDATE = "setContestUsingSelectedCandidate";
export const SET_LANGUAGE = "setLanguage";
export const SET_SEARCH = "setSearch";